import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { getCurrentUser } from '@aws-amplify/auth';
import CompanyDashboard from './components/CompanyDashboard';

const CompanyApp = () => {
  useEffect(() => {
    // Verify company user is logged in
    const checkCompanyUser = async () => {
      try {
        const user = await getCurrentUser();
        const companyID = localStorage.getItem('companyID');
        const userType = localStorage.getItem('userType');

        if (!user || !companyID || userType !== 'company') {
          console.error('Invalid company session');
          window.location.href = '/login';
        }
      } catch (error) {
        console.error('Company auth check failed:', error);
        window.location.href = '/login';
      }
    };

    checkCompanyUser();
  }, []);

  return (
    <Router>
      <Routes>
        {/* Company dashboard routes - wildcard to handle all sub-routes */}
        <Route path="/company/*" element={<CompanyDashboard />} />
        
        {/* Default redirect only for root path */}
        <Route path="/" element={<Navigate to="/company/dashboard" replace />} />
      </Routes>
    </Router>
  );
};

export default CompanyApp;
